import { useState, useEffect, useRef } from "react";

export default function RoleMultiSelectDropdown({
  values = [],
  onChange,
  availableRoles = [],
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null); // ref to detect outside click

  const toggleRole = (roleId) => {
    const updated = values.includes(roleId)
      ? values.filter((id) => id !== roleId)
      : [...values, roleId];
    onChange(updated);
  };

  const selectedLabels =
    availableRoles
      .filter((r) => values.includes(r.id))
      .map((r) => r.description || r.name)
      .join(", ") || "Sélectionner des rôles";

  // 🔁 Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="form-control w-full relative" ref={dropdownRef}>
      <label className="label">
        <span className="label-text font-semibold">Rôles</span>
      </label>

      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="btn w-full justify-between bg-base-100 border border-gray-300"
      >
        <span className="truncate text-left">{selectedLabels}</span>
        <span className="ml-2">&#9662;</span>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 z-50 mt-1 w-full bg-base-100 border rounded-box shadow max-h-60 overflow-y-auto">
          <ul className="menu">
            {availableRoles.map((role) => (
              <li key={role.id}>
                <label className="flex items-center gap-2 px-4 py-2 hover:bg-base-200 cursor-pointer">
                  <input
                    type="checkbox"
                    className="checkbox checkbox-sm"
                    checked={values.includes(role.id)}
                    onChange={() => toggleRole(role.id)}
                  />
                  <span>{role.description}</span>
                </label>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
